import { SET_CARRITOPROMOS } from "../constanst";

const initialState = {
    carritoPromos: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_CARRITOPROMOS:
            return {
                ...state,
                carritoPromos: action.payload
            }
        default:
            return state;
    }
}